export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: 'Where are you based, and do you work remotely?',
    answer:
      'We are based in Puerto Rico. We work with local businesses on the island and with remote clients elsewhere.',
  },
  {
    question: 'Do you build in Spanish?',
    answer:
      'Yes. Like Family and RB Car Care are Spanish-language products, and Raíces y Patitas is bilingual (Spanish and English).',
  },
  {
    question: 'What happens after launch?',
    answer:
      'We offer maintenance and support engagements: monitoring, security patches, bug fixes, and ongoing feature work as your product grows.',
  },
  {
    question: 'Can you take over an existing codebase?',
    answer:
      'Yes. We do security reviews and ongoing maintenance for code that is already in production, including code we did not write.',
  },
  {
    question: 'How do we start?',
    answer:
      'Book a consultation or send us a message. Discovery is the first step: we learn what you need and recommend a scope before any build work begins.',
  },
];
